import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

function AIResponseError({
  message = 'Resource generation failed.',
  resource = 'Resource',
  onGenerateNew,
  onGoToDashboard,
}) {
  return (
    <Box className="mss__box mss__aiResponseError">
      <FontAwesomeIcon icon={faExclamationCircle} className="errorIcon" />

      <Typography className="errorMessage">{message}</Typography>

      <Box className="errorActions">
        {onGoToDashboard && (
          <Button variant="contained" className="mss__button" onClick={onGoToDashboard}>
            Go to Dashboard
          </Button>
        )}
        {onGenerateNew && (
          <Button variant="contained" className="mss__button primary" onClick={onGenerateNew}>
            Generate New {resource}
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default AIResponseError;
